import { render, staticRenderFns } from "./NavVertical.vue?vue&type=template&id=0f494a9c&"
import script from "./NavVertical.vue?vue&type=script&lang=js&"
export * from "./NavVertical.vue?vue&type=script&lang=js&"
import style0 from "./NavVertical.vue?vue&type=style&index=0&id=0f494a9c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports